module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-07.11401257.png";